import { Button, Tooltip } from "antd";
import { SvgIcon } from "assets/icons";
import ImportExcelModal from "../../components/ImportExcelModal";
import ModalSelectProductDialog, { defaultModalSelectProductTrigger } from "./ModalSelectProductDialog";
import useModalSelectProduct from "./useModalSelectProduct";
import "./index.scss";

function ModalSelectProduct({
  form,
  isUpdate,
  dataProductsServer,
  handleGetDataSource,
  dataSourceSelected,
  idDeleted,
}) {
  const hookState = useModalSelectProduct({
    form,
    isUpdate,
    dataProductsServer,
    handleGetDataSource,
    dataSourceSelected,
    idDeleted,
  });

  return (
    <div className="custom-modal-select-product">
      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
        <ModalSelectProductDialog
          visible={hookState.isModalSelectProduct}
          onOpen={hookState.openModalSelectProduct}
          onCancel={hookState.closeModalSelectProduct}
          onConfirm={hookState.handleSelectProduct}
          trigger={defaultModalSelectProductTrigger}
          showTrigger
          isUpdate={isUpdate}
          hookState={hookState}
        />
        <ImportExcelModal
          campaignType="DISCOUNT_PRODUCT"
          onImportSuccess={handleGetDataSource}
          title="Upload file thông tin khuyến mãi"
        >
          <Tooltip title="Upload danh sách sản phẩm">
            <Button icon={<SvgIcon.Xlsx width={28} height={28} />} type="text" />
          </Tooltip>
        </ImportExcelModal>
      </div>
    </div>
  );
}

export default ModalSelectProduct;
